import React, { Children } from 'react'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import { get } from 'utils/lodash'
import { setInvoiceDownloadFailureDialogState } from 'slices/download/DownloadSlice'
import T from 'T'

const InvoiceDownloadFailureDialog = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(state => get(state, 'Download.invoiceDownloadFailureDialog.isOpen', false), shallowEqual)
  const invoices = useSelector(state => get(state, 'Download.invoiceDownloadFailureDialog.invoices', []), shallowEqual)

  const handleClose = () => dispatch(setInvoiceDownloadFailureDialogState({ isOpen: false, invoices: [] }))

  return (
    <HHBaseDialog open={isOpen} onClose={handleClose}>
      <HHDialogTitle title={T.FAILED_DOWNLOAD} onClose={handleClose} />
      <DialogContent>
        <DialogContentText>
          <Typography variant="h5" color="textPrimary" fontWeight={400} mb={1}>
            {T.FAILED_TO_DOWNLOAD_INVOICES}
          </Typography>
          {Children.toArray(
            invoices.map(invoice => (
              <Typography variant="h5" color="textPrimary">
                {invoice}
              </Typography>
            ))
          )}
        </DialogContentText>
      </DialogContent>
      <HHDialogActions>
        <Button size="small" variant="contained" color="primary" onClick={handleClose}>
          OK
        </Button>
      </HHDialogActions>
    </HHBaseDialog>
  )
}

export default InvoiceDownloadFailureDialog
